import React, { useMemo } from 'react';
import { FormControl, Select, MenuItem, Stack, Typography } from '@mui/material';

function PackDropdown({ packs, selectedPack, onSelectPack }) {

    function handlePackChange(packId) {
        onSelectPack(packId);
    }

    const sortedPacks = useMemo(() => {
        if (!packs) return [];
        return [...packs].sort((a, b) => (b.reviewed_usage_percentage ?? 0) - (a.reviewed_usage_percentage ?? 0));
    }, [packs]);

    return (
        <FormControl variant="outlined" sx={{ width: '50%' }}>
            <Select
                value={selectedPack}
                onChange={(e) => handlePackChange(e.target.value)}
                displayEmpty
                p={0.5}
                sx={{
                    fontSize: '16px',
                    display: 'flex',
                    backgroundColor: 'white',
                }}
            >
                <MenuItem value="">
                    <em>Select a pack...</em>
                </MenuItem>
                { sortedPacks.map((pack) => (
                    <MenuItem key={pack.id} value={pack.id}>
                        <Stack direction="row" sx={{ justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                            <Typography variant="normal">{pack.items[0].name}</Typography>
                            <Typography variant="normal" color="text.secondary" sx={{ fontSize: '14px' }}>
                                {(pack.reviewed_usage_percentage ?? 0) == 0
                                    ? 'Not reviewed'
                                    : `${((pack.reviewed_usage_percentage) * 100).toFixed(0)}% reviewed`}
                            </Typography>
                        </Stack>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default PackDropdown;